import { UserRegistryStatus } from '@cp-mx/common';
import { AuthorizationResult } from '@cp-shared-19/frontend-ui';
import { Reducer } from 'redux';

export const authorizationReducer: Reducer<AuthorizationResult<UserRegistryStatus>> = (
    state = { isAuthorized: false, isRegistered: false },
    action,
) => (action.type === 'Authorization' ? action.authorizationResult : state);
